import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import { tick } from "./slices/fleetSlice";

export function useSimClock() {
  const dispatch = useDispatch();
  const playing = useSelector((s: RootState) => s.fleet.playing);
  const speed = useSelector((s: RootState) => s.fleet.speed);
  const raf = useRef<number | null>(null);
  const last = useRef<number>(0);

  useEffect(() => {
    function loop(t: number) {
      if (!last.current) last.current = t;
      const dt = t - last.current;
      last.current = t;
      if (playing) dispatch(tick({ dtMs: dt * speed }));
      raf.current = requestAnimationFrame(loop);
    }
    raf.current = requestAnimationFrame(loop);
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, [playing, speed, dispatch]);
}
